import { fade, makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  glossary: {
    display: "flex",
    overflowY: "hidden",
    height: "75vh",
    "@media print": {
      height: "auto",
    },
  },
  categoryToolbar: {
    margin: theme.spacing(0, 3, 3, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  termsList: {
    height: "75vh",
    width: "100%",
    padding: theme.spacing(3),
    overflowY: "auto",
    "@media print": {
      height: "auto",
    },
  },
  noPrint: {
    "@media print": {
      display: "none",
    },
  },
  glossaryCategories: {
    padding: theme.spacing(3),
    width: 280,
    overflowY: "auto",
  },
  categoryToobarActions: {
    display: "flex",
    width: 240,
    justifyContent: "flex-end",
    alignItems: "flex-start",
  },
  sortContainer: {
    display: "flex",
    gap: 7,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.primary.main,
    padding: "6px 10px",
    cursor: "pointer",
  },
  sortTitle: {
    fontWeight: 600,
    lineHeight: 2.75,
    letterSpacing: "0.02857em",
    marginLeft: 5,
  },
  sortDisabled: {
    fill: "rgba(0, 0, 0, 0.26)",
  },
  sortActive: {
    fill: theme.palette.primary.main,
  },
  exhibitorBackToTop: {
    marginBottom: "94px",
    position: "fixed !important" as any,
    marginRight: "24px",
    zIndex: 1,
  },
  contrast: {
    color: `${theme.palette.contrastText.main} !important`,
    background: `${theme.palette.otherElementsBackground.main} !important`,
    "& a": {
      color: `${theme.palette.contrastText.main}`,
    },
  },
}));

export const VIDEO_TOOLTIP_BOTTOM = "-55px";

/** Styles for the library banners and locked fields on the section form. */
export const useLibraryLinkStyles = makeStyles((theme) => ({
  /*
   * What both banners share. The shared `Alert` pads 16 all round, these are
   * status strips — so the padding lives in the modifiers below. `&&` to beat
   * `Alert`'s own `root` class, `!important` because it sets the background
   * inline.
   */
  banner: {
    "&&": {
      backgroundColor: `${fade(theme.palette.primary.main, 0.08)} !important`,
    },
    "& .MuiAlert-icon": {
      marginRight: 6,
    },
  },
  /** Banner above a form field that is not otherwise spaced: 24 below. */
  bannerGap: {
    marginBottom: theme.spacing(3),
  },
  // Inherited: 4/8/4/12 — the right side trimmed for the `⋮` — and 24 below.
  linkedBanner: {
    marginBottom: theme.spacing(3),
    "&&": {
      padding: "4px 8px 4px 12px",
    },
  },
  /** Local section: 12 either side, 16 below, and no leading icon. */
  localBanner: {
    marginBottom: theme.spacing(2),
    "&&": {
      padding: "4px 12px",
    },
  },
  /** `ADD TO LIBRARY`: 8 around, and 8 between the label and the book. */
  addToLibrary: {
    padding: theme.spacing(1),
    "& .MuiButton-endIcon": {
      marginLeft: theme.spacing(1),
      marginRight: 0,
    },
  },
  bannerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 6,
    width: "100%",
  },
  bannerIcon: {
    color: theme.palette.primary.main,
  },
  // Blue/A400 — this theme's `primary.main` exactly — at 14/500/20, 0.4 tracking.
  bannerText: {
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: 0.4,
  },
  lockedField: {
    marginBottom: theme.spacing(3),
  },
  // The lock sits inside, top-right: 16 padding, 10 to the text.
  lockedBody: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.action.hover,
    padding: theme.spacing(2),
  },
  /** Scrolls on the text alone, so the lock stays put. */
  lockedBodyContent: {
    flex: 1,
    minWidth: 0,
    maxHeight: 320,
    overflowY: "auto",
  },
  lockIcon: {
    fontSize: 24,
    color: theme.palette.grey[400],
    flexShrink: 0,
  },
  // Popup/unsaved changes: 480 wide, 24 top and sides, 16 below the buttons.
  // `&&` to beat `ConfirmModal`'s own root and title classes.
  saveBeforePushModal: {
    "&&": {
      width: 480,
      paddingBottom: theme.spacing(2),
    },
  },
  saveBeforePushTitle: {
    "&&": {
      marginBottom: theme.spacing(2),
    },
  },
}));
